<script setup lang="tsx">
import * as Chartist from 'chartist'
import { ref, onMounted, watch } from 'vue'
import type { ModuleStatuses } from '@/models/api-generated'
import { drawLines } from '@/components/donut'

const model = defineModel<ModuleStatuses>({ required: true })
const chart = ref(null)
let pieChart: Chartist.PieChart

const opts: Chartist.PieChartOptions = {
	donut: true,
	donutWidth: 40,
	startAngle: 45,
	showLabel: true,
	labelInterpolationFnc: (a) => (a ? a + '%' : null),
}

function getSeries() {
	return [
		{ className: 'pie1', value: model.value.i?.percentage || 0 },
		{ className: 'pie-ci', value: model.value.ci?.percentage || 0 },
		{ className: 'pie2', value: model.value.pi?.percentage || 0 },
		{ className: 'pie3', value: model.value.ni?.percentage || 0 },
		{ className: 'pie6', value: model.value.na?.percentage || 0 },
		{ className: 'pie4', value: model.value.wna?.percentage || 0 },
		{ className: 'pie-wni', value: model.value.wni?.percentage || 0 },
	]
}

onMounted(() => {
	if (!model.value) return
	pieChart = new Chartist.PieChart(chart.value, { series: getSeries() }, opts)
	drawLines(pieChart)
})

watch(model, (newVal) => {
	if (!pieChart || !newVal) return
	pieChart.update({ series: getSeries() })
})
</script>

<template>
	<div class="rounded-container p-4 overflow-auto text-nowrap">
		<p class="text-center fw-bold">
			{{ $t('risk.mitigationMeasure', 2) }}
		</p>
		<div class="d-flex justify-content-center align-items-center" :class="{ active: !model }">
			<div ref="chart" class="chart"></div>
			<div class="position-absolute text-center">
				<h6 class="chart-content m-0">{{ $t('status.implemented') }} {{ model.i.percentage }}%</h6>
			</div>
			<Transition>
				<div v-if="!model" class="position-absolute">
					<div class="spinner-border text-primary"></div>
				</div>
			</Transition>
		</div>
	</div>
</template>

<style lang="sass">
.pie-ci
  stroke: url(#greenLinePattern)

.pie-wni
  stroke: url(#greyLinePattern)
</style>

<style lang="sass" scoped>
.v-enter-active,
.v-leave-active,
.chart
  transition: opacity 0.2s ease

.v-enter-from,
.v-leave-to
  opacity: 0

.active
  opacity: .6

.chart
  height: 300px
</style>
